"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Copyright (c) React Native Community.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
class WebStorage {
  constructor() {
    let sessionStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    _defineProperty(this, "storage", void 0);
    this.storage = sessionStorage ? window.sessionStorage : window.localStorage;
  }
  async getSingle(key, opts) {
    if (opts) {// noop
    }
    return this.storage.getItem(key);
  }
  async setSingle(key, value, opts) {
    if (opts) {// noop
    }
    return this.storage.setItem(key, value);
  }
  async getMany(keys, opts) {
    if (opts) {// noop
    }
    return keys.reduce((storageValues, key) => {
      return _objectSpread({}, storageValues, {
        [key]: this.storage.getItem(key)
      });
    }, {});
  }
  async setMany(values, opts) {
    if (opts) {// noop
    }
    for (let keyValue of values) {
      const key = Object.getOwnPropertyNames(keyValue)[0];
      if (!key) {
        continue;
      }
      this.storage.setItem(key, keyValue[key]);
    }
  }
  async removeSingle(key, opts) {
    if (opts) {// noop
    }
    return this.storage.removeItem(key);
  }
  async removeMany(keys, opts) {
    if (opts) {// noop
    }
    Promise.all(keys.map(k => this.storage.removeItem(k)));
  }
  async getKeys(opts) {
    if (opts) {// noop
    }
    return Object.keys(this.storage);
  }
  async dropStorage(opts) {
    if (opts) {// noop
    }
    const keys = await this.getKeys();
    await this.removeMany(keys);
  }
}
var _default = WebStorage;
exports.default = _default;